"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setShowMenu = exports.setPageTitle = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    pageTitle: "Not Set",
    showMenu: true,
};
const slice = (0, toolkit_1.createSlice)({
    name: "console",
    initialState,
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload;
        },
        setShowMenu: (state, action) => {
            state.showMenu = action.payload;
        },
    },
});
_a = slice.actions, exports.setPageTitle = _a.setPageTitle, exports.setShowMenu = _a.setShowMenu;
exports.default = slice.reducer;
